export const D1_WORKER_URL = 'd1-rest-lavaflowstreams.jxrstudios-damascusai.workers.dev'
export const CLOUDFLARE_ACCOUNT_ID = '375f38584aa743037e9b1cee1820334e'
export const D1_BASE_URL = `https://${D1_WORKER_URL}`
export const WORKER_NAME = 'api.lavaflowstreams.pro'
export const PLATFORM_NAME = 'LavaFlow Streams'
export const PLATFORM_DOMAIN = 'lavaflowstreams.pro'

export const AI_PROVIDERS = [
  {
    id: 'cloudflare-ai',
    name: 'Cloudflare Workers AI',
    logo: 'cf',
    endpoint: 'https://gateway.ai.cloudflare.com/v1',
    models: ['@cf/meta/llama-3.1-8b-instruct', '@cf/meta/llama-3.3-70b-instruct-fp8-fast', '@cf/mistral/mistral-7b-instruct-v0.1'],
    color: 'oklch(0.68 0.22 42)',
  },
  {
    id: 'openai',
    name: 'OpenAI',
    logo: 'openai',
    endpoint: 'https://api.openai.com/v1',
    models: ['gpt-4o', 'gpt-4o-mini', 'gpt-4-turbo'],
    color: 'oklch(0.65 0.18 145)',
  },
  {
    id: 'anthropic',
    name: 'Anthropic',
    logo: 'anthropic',
    endpoint: 'https://api.anthropic.com/v1',
    models: ['claude-opus-4-5', 'claude-sonnet-4-5', 'claude-haiku-3-5'],
    color: 'oklch(0.72 0.16 200)',
  },
  {
    id: 'ollama',
    name: 'Ollama (Local)',
    logo: 'ollama',
    endpoint: 'http://localhost:11434/v1',
    models: ['llama3.2', 'mistral', 'codellama', 'phi3'],
    color: 'oklch(0.7 0.12 260)',
  },
  {
    id: 'vercel-ai-gateway',
    name: 'Vercel AI Gateway',
    logo: 'vercel',
    endpoint: 'https://api.vercel.ai/v1',
    models: ['openai/gpt-4o-mini', 'anthropic/claude-opus-4-5', 'google/gemini-3-flash'],
    color: 'oklch(0.6 0 0)',
  },
  {
    id: 'custom',
    name: 'Custom Provider',
    logo: 'custom',
    endpoint: '',
    models: [],
    color: 'oklch(0.7 0.18 85)',
  },
] as const

export const KEY_PERMISSIONS = [
  { id: 'ai:stream', label: 'AI Stream', description: 'Stream AI completions via gateway' },
  { id: 'ai:embed', label: 'AI Embed', description: 'Generate embeddings' },
  { id: 'db:read', label: 'Database Read', description: 'Read from D1 database' },
  { id: 'db:write', label: 'Database Write', description: 'Write to D1 database' },
  { id: 'storage:read', label: 'Storage Read', description: 'Read from R2 bucket' },
  { id: 'storage:write', label: 'Storage Write', description: 'Write to R2 bucket' },
  { id: 'kv:read', label: 'KV Read', description: 'Read KV namespace' },
  { id: 'kv:write', label: 'KV Write', description: 'Write KV namespace' },
  { id: 'admin', label: 'Admin', description: 'Full administrative access' },
] as const

export const API_VERSION = 'v1'
